import { action, extendObservable, reaction } from 'mobx';
import PropTypes from 'prop-types';
import { apiCall } from '../API';
import { POLICY_MIGRATION_STEP_ENUM } from '../constants';
import AsyncActionStore from './AsyncActionStore';
import BoolStore from './helpers/BoolStore';
import ValueStore from './helpers/ValueStore';

export default class PolicyMigrationStore {
    static PropType = PropTypes.shape({
        activeStep: ValueStore.PropTypes,
        viewedStep: ValueStore.PropTypes,
        modalIsOpen: BoolStore.PropTypes,
        confirmIsOpen: BoolStore.PropTypes,
        confirmation: BoolStore.PropTypes,
        saveStatus: AsyncActionStore.PropType,
        save: PropTypes.func.isRequired,
        apiUpdate: PropTypes.func.isRequired,
    });

    static stepNumberFromString = (stepString) =>
        Object.keys(POLICY_MIGRATION_STEP_ENUM).indexOf(stepString) + 1;

    constructor(data = {}) {
        extendObservable(this, /** @class PolicyMigrationStore */{
            activeStep: new ValueStore(1),
            viewedStep: new ValueStore(1),
            modalIsOpen: new BoolStore(false),
            confirmIsOpen: new BoolStore(false),
            confirmation: new BoolStore(false),
            saveStatus: new AsyncActionStore(),
            apiUpdate: apiCall('/console/policy-migration/update')
        }, data);

        reaction(this.confirmIsOpen.getValue, () => {
            this.confirmation.setValue(false);
        });
    }

    stringFromStepNumber = (step) =>
        Object.keys(POLICY_MIGRATION_STEP_ENUM)[step - 1];

    save = action(() => {
        const step = this.viewedStep.getValue();
        const stringStep = this.stringFromStepNumber(step);

        if (!this.saveStatus.isLoading) {
            this.saveStatus.setLoading(
                this.apiUpdate(stringStep).then((response) => ({ ...response, step }))
            );
        }
        return this.saveStatus.promise;
    });
}
